import React from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { PAGE_NAMES } from 'client/site-modules/shared/constants/microsite/dealers/dealers';
import { DealerCenterDecorator } from 'site-modules/microsite/dealers/decorators/dealer-center-decorator';
import { DEALER_CENTER_PAGE_CATEGORY } from 'site-modules/microsite/dealers/constants/page';
import { PageNotFound } from './page-not-found';

export const PageDefinitionConfiguration = {
  name: PAGE_NAMES.PAGE_NOT_FOUND,
  category: DEALER_CENTER_PAGE_CATEGORY,
  seo: {
    title: 'Dealers - Page not found',
    description: '',
    robots: {
      noIndex: true,
      noFollow: true,
    },
  },
  decorator: DealerCenterDecorator,
  component: () => <PageNotFound />,
};

export default pageDefinition(PageDefinitionConfiguration);
